export const RADII = {
  base: "4px",
  none: "none",
  full: "9999px",
};
